import React, { Component } from 'react';
import './CheckoutItem.scss';

class CheckoutItem extends Component {
  render() {
    const { name, total, count } = this.props.item;

    return (
      <div className='checkout-item-row'>
        <p>
          {name} <span className='bold'>({count})</span>
        </p>
        <p>Item total: ${total.toFixed(2)}</p>
      </div>
    );
  }
}

export default CheckoutItem;
